import type { CompanyReceiptView } from "./companyReceiptContracts";

/** Presentation only: each server evidence state keeps its own distinct label. */
export const invoiceEvidenceLabel: Record<CompanyReceiptView["invoice_state"], string> = {
  verified_paid: "Payment verified",
  pending: "Payment pending",
  uncertain: "Payment status unknown",
  failed: "Payment failed",
  refunded: "Payment refunded",
};
